var u = Object.defineProperty;
var d = Object.getOwnPropertySymbols;
var f = Object.prototype.hasOwnProperty, l = Object.prototype.propertyIsEnumerable;
var s = (e, t, a) => t in e ? u(e, t, { enumerable: !0, configurable: !0, writable: !0, value: a }) : e[t] = a, m = (e, t) => {
  for (var a in t || (t = {}))
    f.call(t, a) && s(e, a, t[a]);
  if (d)
    for (var a of d(t))
      l.call(t, a) && s(e, a, t[a]);
  return e;
};
var c = (e, t) => {
  var a = {};
  for (var r in e)
    f.call(e, r) && t.indexOf(r) < 0 && (a[r] = e[r]);
  if (e != null && d)
    for (var r of d(e))
      t.indexOf(r) < 0 && l.call(e, r) && (a[r] = e[r]);
  return a;
};
import o, { forwardRef as p } from "react";
const E = p(function(L, i) {
  var n = L, { testId: t = "fs-loader", variant: a = "dark" } = n, r = c(n, ["testId", "variant"]);
  return o.createElement(
    "span",
    m({ ref: i, "data-fs-loader": !0, "data-fs-loader-variant": a, "data-testid": t }, r),
    o.createElement("span", { "data-fs-loader-item": !0 }),
    o.createElement("span", { "data-fs-loader-item": !0 }),
    o.createElement("span", { "data-fs-loader-item": !0 })
  );
}), v = E;
export {
  v as default
};
